<script setup lang="ts">
import { computed } from 'vue';
import { PRODUCT_LOGO_ASSET, PRODUCT_LOGO_STYLE } from '@/constants';
import AgentSelectionCard from '@/components/home/agent-selection/agent-selection-card.vue';
import { FunctionKey } from '@/types';
import { AGENT_INTRODUCTIONS } from '@/utils/agentIntroductions';

const props = defineProps<{
  availableFunctions: FunctionKey[];
}>();

const agents = computed(() =>
  AGENT_INTRODUCTIONS.filter(agent =>
    props.availableFunctions.includes(agent.key),
  ),
);
</script>

<template>
  <div class="agent-selection">
    <header class="header">
      <img
        :src="PRODUCT_LOGO_ASSET"
        :style="PRODUCT_LOGO_STYLE"
        alt="Aconnect"
      />
    </header>
    <main class="content">
      <div class="lead">
        <h1 class="c-title-bold--xl">
          Aconnectへようこそ！<br />まずはエージェントを選んで、試してみましょう
        </h1>
      </div>
      <div v-if="agents.length > 0" class="cards">
        <AgentSelectionCard
          v-for="agent in agents"
          :key="agent.key"
          :agent="agent"
        />
      </div>
      <p v-else class="c-text-regular--m empty">
        現在利用できるエージェントがありません。管理者にお問い合わせください。
      </p>
    </main>
  </div>
</template>

<style lang="scss" scoped>
.agent-selection {
  min-height: 100vh;
  background: $color-white;
}

.header {
  display: flex;
  align-items: center;
  box-sizing: border-box;
  height: 64px;
  padding: 12px;
  background: $color-white;
  box-shadow: 0 1px 5px rgba(74, 74, 74, 0.25);
}

.content {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 24px 40px;
}

.lead {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 24px 0;
  text-align: center;

  h1 {
    margin: 0;
    color: $color-gray1000;
  }
}

// 1枚のときだけ中央に置くため、空いた列を潰す auto-fit にする
.cards {
  display: grid;
  grid-template-columns: repeat(auto-fit, 448px);
  justify-content: center;
  gap: 16px;
  width: 100%;
  max-width: 912px;
}

.empty {
  color: $color-gray800;
}
</style>
